/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Image, Container, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { SpinnerDotted } from "spinners-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import styles from "./viewUser.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import ToggleButtonOnOff from "../../components/ToggleButton/ToggleButton";
import { REACT_APP_API_BLOCK_USER } from "../../redux/apiConstants";

function ViewUsers() {
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { viewformStyle } = useContext(TableContext);
  const params = useParams();
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState([]);
  const [roles, setRole] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);
  const dateFormat = getCookies("dateFormat");
  let statusCode;
  const getUserDetails = async (id) => {
    const uid = id ?? params.userId;
    if (!uid) return;
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/appuser/${uid}`, {
        method: "GET",
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        console.log(res.data.user, "ress");
        if (statusCode === 200) {
          setDetails(res.data.user);
          setRole(res.data.user.role);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  const navigate = useNavigate();
  const appUserId = details?.id ?? details?._id ?? params.userId;

  const handleBlockUser = () => {
    if (details?.communityBlocked === true) {
      toast.info("This user is already blocked from the community");
      return;
    }
    confirmAlert({
      title: "Block User",
      message: "Are you sure you want to block this user? They will no longer be able to post in the Community Feed.",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            setActionLoading(true);
            try {
              const response = await axios.patch(
                `${REACT_APP_API_BLOCK_USER}/${appUserId}/block`,
                {},
                { headers: { Authorization: token } }
              );
              if (response.status === 200 || response.status === 204) {
                toast.success("User blocked successfully");
                getUserDetails(params.userId);
              }
            } catch (error) {
              const errorMessage = error.response?.data?.message || "Failed to block user. Please try again.";
              toast.error(errorMessage);
            } finally {
              setActionLoading(false);
            }
          },
        },
        { label: "No" },
      ],
    });
  };

  const handleUnblockUser = () => {
    if (details?.communityBlocked !== true) {
      toast.info("This user is not blocked from the community");
      return;
    }
    confirmAlert({
      title: "Unblock User",
      message: "Are you sure you want to unblock this user? They will be able to post in the Community Feed again.",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            setActionLoading(true);
            try {
              const response = await axios.patch(
                `${REACT_APP_API_BLOCK_USER}/${appUserId}/unblock`,
                {},
                { headers: { Authorization: token } }
              );
              if (response.status === 200 || response.status === 204) {
                toast.success("User unblocked successfully");
                getUserDetails(params.userId);
              }
            } catch (error) {
              const errorMessage = error.response?.data?.message || "Failed to unblock user. Please try again.";
              toast.error(errorMessage);
            } finally {
              setActionLoading(false);
            }
          },
        },
        { label: "No" },
      ],
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (params.userId) {
      getUserDetails(params.userId);
    }
    setDashboardHeader("User Details");
  }, [params.userId]);
  return (
    <div className={styles[bodyStyle]}>
      <div
        className={styles[dashboardStyle]}
        style={{ height: "100vh" }}
        id={styles.dashboardcont2}
      >
        <div className={styles[formthemeStyle]} id={styles.addform}>
          {loading ? (
            <SpinnerDotted
              style={{
                color: "#39979d",
                left: "50%",
                position: "relative",
                textAlign: "center",
                top: "50%",
              }}
            />
          ) : (
            <Container fluid>
              <FontAwesomeIcon
                icon={faArrowLeft}
                value="Back"
                onClick={() => {
                  navigate(-1);
                }}
                className={styles.arrowback}
              />
              <Row>
                <Col lg={12}>
                  <div className={styles.profilepicdiv}>
                    <Image
                      src={
                        details?.image
                          ? details?.image
                          : "https://meditation-crush-staging.s3.amazonaws.com/uploads/dummy.jpg-1714036221086"
                      }
                      // src={details?.image}
                      alt="logo"
                      className={styles.profilepic}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg={12} md={12} sm={12}>
                  <div className={styles.detaildiv}>
                    <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Name</span>
                          <p className={styles.empname}>{details.name}</p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Email</span>
                          <p className={styles.empname}>{details.email}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Phone</span>
                          <p className={styles.empname}>{details.phone}</p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Signed-up date</span>
                          <p className={styles.empname}>
                            {details.createdAt
                              ? DateFormatter(
                                  details.createdAt,
                                  "toLocaleDateString"
                                )
                              : "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Status</span>

                          <p className={styles.empname}>
                            {" "}
                            {details.active ? "Active" : "Inactive"}
                          </p>
                        </div>
                      </Col>
                      {details.communityBlocked != null && (
                        <Col lg={4}>
                          <div
                            className={styles[viewformStyle]}
                            id={styles.empdiv}
                          >
                            <span className={styles.title}>Community access</span>
                            <p className={styles.empname}>
                              {details.communityBlocked ? "Blocked" : "Allowed"}
                            </p>
                          </div>
                        </Col>
                      )}
                    </Row>
                    {!loading && details && Object.keys(details).length > 0 && (
                      <Row className="mt-4">
                        <Col lg={12}>
                          <div className={styles.actionsSection}>
                            <h5 className={styles.actionsTitle}>Actions</h5>
                            <div className={styles.actionButtons}>
                              <Button
                                variant={details?.communityBlocked === true ? "success" : "warning"}
                                className={styles.actionBtn}
                                onClick={details?.communityBlocked === true ? handleUnblockUser : handleBlockUser}
                                disabled={actionLoading}
                              >
                                <i className={details?.communityBlocked === true ? "fa fa-check-circle" : "fa fa-ban"} style={{ marginRight: "8px" }} />
                                {details?.communityBlocked === true ? "Unblock from community" : "Block from community"}
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                    {/* <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>DOB</span>
                          <p className={styles.empname}>
                            {details.dateOfBirth
                              ? DateFormatter(
                                  details.dateOfBirth,
                                  dateFormat || "toDateString"
                                )
                              : "NA"}
                          </p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Status</span>
                          <p className={styles.empname}>
                            {details.active ? "Active" : "InActive"}
                          </p>
                        </div>
                      </Col>
                    </Row> */}
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewUsers;
